import React from 'react'

function MenuBurger() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <path
        fill="#FFF"
        fillRule="evenodd"
        d="M27 22a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2h24zm0-8a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2h24zm0-8a1 1 0 0 1 0 2H3a1 1 0 1 1 0-2h24z"
      />
    </svg>
  )
}

export default MenuBurger
